import { pageHeight } from "../functions/windowSizeFunctions";

export default class SetMainHeight {
    constructor() {
        this.header = document.querySelector(".jsHeader");
        this.main = document.querySelector(".jsMain");
        this.footer = document.querySelector(".jsFooter");
        this.noticeContainer = document.querySelector(".jsPageNoticeWrapper");

        this.events();
    }

    events() {
        window.addEventListener(
            "DOMContentLoaded",
            this.setMainHeight.bind(this),
            {
                once: true,
            }
        );

        window.addEventListener("resize", this.setMainHeight.bind(this));
    }

    setMainHeight() {
        let headerHeight = 0;
        let footerHeight = 0;

        const currentPageHeight = pageHeight();

        this.header
            ? (headerHeight = this.header.getBoundingClientRect().height)
            : (headerHeight = 0);
        this.footer
            ? (footerHeight = this.footer.getBoundingClientRect().height)
            : (footerHeight = 0);

        const mainHeight = currentPageHeight - headerHeight - footerHeight;

        if (mainHeight > 0)
            document.documentElement.style.setProperty(
                "--main-height",
                `${mainHeight}px`
            );

        if (headerHeight && this.noticeContainer) {
            this.noticeContainer.style.top = `${headerHeight + 5}px`;
        }

        if (headerHeight) document.body.style.paddingTop = `${headerHeight}px`;
    }
}
